import {AfterViewInit, Component, ElementRef, Input, ViewChild} from '@angular/core';
import {ActivatedRoute} from "@angular/router";
import {DICTIONARY} from "../dictionary";

@Component({
	selector: 'more-info-c',
	template: `
		<div style="position:relative; overflow: visible; margin: 0 7px; display: inline-block;">
			<i class="far fa-question-circle hvr-opacity" style="cursor: pointer; color: var(--ui-text-subtle); font-size: 1.05rem; font-weight: 300; margin-left: -3px; transform: translateY(-2px);"
			   [tooltip]="tooltip"
			   (click)="toggleInstructions()"></i>
			<div class="flxClmn page-info-window" *ngIf="renderInstructions" [ngClass]="{'shown' : showInstructions}">
				<div class="flxRow-between title-row w100" style="position: sticky; top: 0;">
					<div class="flxRow hSpace05" style="align-items: center">
						<i style="font-size: 0.95rem; opacity: 0.5;" class="far fa-info-circle"></i>
						<span style="font-size: 0.95rem;">Information</span>
					</div>
					<a style="font-size: 1.2rem; padding: 0 7px;" class="close1 closeRed" (click)="toggleInstructions()">
						<i class="zmdi zmdi-close"></i>
					</a>
				</div>
				<div class="flxRow hSpace2 content-wrapper" #contentWrapper style="flex: 1 0;">
					<ng-content></ng-content>
				</div>
				<div *ngIf="docsUrl" class="guide-link-wrapper flxRow hSpace05" style="align-self: flex-end; font-weight: 500;">
					<span>Full guide:</span>
					<a class="a-link" [href]="docsUrl" target="_blank">{{docsTitle}}</a>
				</div>
			</div>
		</div>
    `
})
export class MoreInfoComponent implements AfterViewInit {

	@Input() docsUrl = this.activatedRoute.snapshot.data?.docs?.url ? DICTIONARY.CONSTANTS.trustifiDefault.resources.docsGeneral + this.activatedRoute.snapshot.data.docs.url : '';
	@Input() docsTitle = this.activatedRoute.snapshot.data?.docs?.title || '';
	tooltip = `Go to docs: "${this.docsTitle}"`;

	@ViewChild('contentWrapper') contentWrapperEl: ElementRef;

	constructor(private activatedRoute: ActivatedRoute) {
	}

	showInstructions = false;
	renderInstructions = true;

	// avoid NG0100 error
	ngAfterViewInit() {
		setTimeout(() => {
			this.renderInstructions = this.contentWrapperEl?.nativeElement?.children?.length;
			this.tooltip = this.renderInstructions ? 'More info' : `Go to docs: "${this.docsTitle}"`;
		});
	}

	toggleInstructions() {
		// in case there's content for info window - show window
		if (this.renderInstructions) {
			this.showInstructions = !this.showInstructions;
		}
		// in case there's NO content for info window - link to docs
		else if (this.docsUrl) {
			window.open(this.docsUrl, '_blank', 'noopener,noreferrer');
		}
	}
}
